const handleSortPayload = (searchForm: any) => {
  switch (searchForm?.value?.sort_by?.value) {
    case "all_properties":
      return "reserve_price:asc";

    case "reserve_price_asc":
      return "reserve_price:asc";

    case "reserve_price_desc":
      return "reserve_price:desc";

    default:
      return "reserve_price:asc";
  }
};

const getFilterForSubAssetType = (searchForm: any) => {
  const filters = [];
  if (searchForm.value.asset_type.value) {
    const currentFilterString = `dump.asset.asset_type_slug:=${searchForm.value.asset_type.value}`;
    filters.push(currentFilterString);
  }
  return filters;
};
const getFilterForLocationCityType = (searchForm: any) => {
  const filters = [];
  if (searchForm.value.state.value) {
    const currentFilterString = `dump.location.state_slug:=${searchForm.value.state.value}`;
    filters.push(currentFilterString);
  }

  if (searchForm?.value?.city?.value && searchForm?.value?.city?.label) {
    const currentFilterString = `dump.location.city_name:=${searchForm.value.city.label}`;
    filters.push(currentFilterString);
  }
  return filters;
};
const getFilterForLocationStateType = (searchForm: any) => {
  const filters = [];
  if (searchForm.value.asset_type.value) {
    const currentFilterString = `dump.asset.asset_type_slug:=${searchForm.value.asset_type.value}`;
    filters.push(currentFilterString);
  }
  if (searchForm.value.state.value) {
    const currentFilterString = `dump.location.state_slug:=${searchForm.value.state.value}`;
    filters.push(currentFilterString);
  }

  if (searchForm?.value?.city?.value && searchForm?.value?.city?.label) {
    const currentFilterString = `dump.location.city_name:=${searchForm.value.city.label}`;
    filters.push(currentFilterString);
  }
  return filters;
};
const getFilterForProperties = (searchForm: any, router: any) => {
  const filters = [];
  if (searchForm.value.asset_type.value) {
    const currentFilterString = `dump.asset.asset_type_slug:=${searchForm.value.asset_type.value}`;
    filters.push(currentFilterString);
  }

  if (
    Array.isArray(searchForm.value.sub_asset_type) &&
    searchForm.value.sub_asset_type.length > 0
  ) {
    const subAssetTypeValues = searchForm.value.sub_asset_type.map(
      (subAssetType: any) => `\`${subAssetType.value}\``
    );

    const subAssetTypeFilterString =
      subAssetTypeValues.length === 1
        ? `dump.asset.sub_asset_type_slug:=${subAssetTypeValues[0]}`
        : `dump.asset.sub_asset_type_slug:=[${subAssetTypeValues.join(", ")}]`;

    filters.push(subAssetTypeFilterString);
  } else if (
    !Array.isArray(searchForm.value.sub_asset_type) &&
    typeof searchForm.value.sub_asset_type === "object"
  ) {
    const subAssetTypeFilterString = `dump.asset.sub_asset_type_slug:=${searchForm.value.sub_asset_type.value}`;
    filters.push(subAssetTypeFilterString);
  }

  if (searchForm.value.state.value) {
    const currentFilterString = `dump.location.state_slug:=${searchForm.value.state.value}`;
    filters.push(currentFilterString);
  }

  if (searchForm?.value?.city?.value && searchForm?.value?.city?.label) {
    const currentFilterString = `dump.location.city_name:=${searchForm.value.city.label}`;
    filters.push(currentFilterString);
  }
  if (searchForm.value.reserve_price) {
    const reserveValuesPair = searchForm.value.reserve_price.split("-");
    reserveValuesPair[0] = parseInt(reserveValuesPair[0]) * 100000;
    reserveValuesPair[1] = parseInt(reserveValuesPair[1]) * 100000;
    const currentFilterString = `reserve_price:=[${reserveValuesPair.join(
      ".."
    )}]`;
    filters.push(currentFilterString);
  }

  if (searchForm.value.locality && searchForm.value.locality.length > 0) {
    const localities = searchForm.value.locality.map(
      (locality: any) => `\`${locality.value}\``
    );

    const localitiesFilterString =
      localities.length === 1
        ? `dump.location.locality_slug:=${localities[0]}`
        : `dump.location.locality_slug:=[${localities.join(", ")}]`;

    filters.push(localitiesFilterString);
  }

  if (searchForm.value.filter_by.value === "auction_verified") {
    const currentFilterString = `ab_verified:=true`;
    filters.push(currentFilterString);
  } else if (
    searchForm.value.ab_verified &&
    searchForm.value.ab_verified.value === "auction_verified"
  ) {
    const currentFilterString = `ab_verified:=true`;
    filters.push(currentFilterString);
  }

  if (searchForm.value.filter_by.value === "financing_avaibility") {
    const currentFilterString = `financing_facility:=true`;
    filters.push(currentFilterString);
  }

  if (searchForm.value.filter_by.value === "featured_properties") {
    const currentFilterString = `featured:=true`;
    filters.push(currentFilterString);
  }

  if (searchForm.value.filter_by.value === "dated") {
    const currentFilterString = `property_date_type:=dated`;
    filters.push(currentFilterString);
  }

  if (searchForm.value.filter_by.value === "private_treaty") {
    const currentFilterString = `property_date_type:=private_treaty`;
    filters.push(currentFilterString);
  }

  if (searchForm.value.filter_by.value === "undated") {
    const currentFilterString = `property_date_type:=undated`;
    filters.push(currentFilterString);
  }

  return filters;
};

export const getSearchPayloadForPrivate = (
  searchForm: any,
  router: any,
  page: number = 1
) => {
  const filters = getFilterForProperties(searchForm, router);

  const returnPayload = [
    {
      q: searchForm.value.listing_id_query
        ? searchForm.value.listing_id_query
        : "*",
      query_by: searchForm.value.listing_id_query ? "listing_id" : "",
      collection: "posted-properties",
      facet_by:
        "dump.asset.asset_type_name,dump.asset.asset_type_slug,dump.asset.sub_asset_type_name,dump.asset.sub_asset_type_slug,dump.location.state_name,dump.location.state_slug,dump.location.city_name,dump.location.city_slug",
      facet_return_parent:
        "dump.asset.asset_type_name,dump.asset.asset_type_slug,dump.asset.sub_asset_type_name,dump.asset.sub_asset_type_slug,dump.location.state_name,dump.location.state_slug,dump.location.city_name,dump.location.city_slug",
      filter: "true",
      max_facet_values: "10000",
      filter_by: filters.join(" && "),
      sort_by: handleSortPayload(searchForm),
      infix: "always",
      prefix: searchForm.value.listing_id_query ? false : true,
      page: page,
    },
    {
      query_by: "",
      collection: "posted-properties",
      q: "*",
      facet_by: "dump.asset.asset_type_name,dump.asset.asset_type_slug,",
      facet_return_parent:
        "dump.asset.asset_type_name,dump.asset.asset_type_slug,",
      filter: "true",
      max_facet_values: "10000",
      infix: "always",
    },
    {
      query_by: "",
      collection: "posted-properties",
      q: "*",
      facet_by: "dump.asset.sub_asset_type_name,dump.asset.sub_asset_type_slug",
      facet_return_parent:
        "dump.asset.sub_asset_type_name,dump.asset.sub_asset_type_slug",
      filter: "true",
      filter_by: getFilterForSubAssetType(searchForm).join(" && "),
      max_facet_values: "10000",
      infix: "always",
    },
    {
      query_by: "",
      collection: "posted-properties",
      q: "*",
      facet_by: "dump.location.state_name,dump.location.state_slug",
      facet_return_parent: "dump.location.state_name,dump.location.state_slug",
      filter: "true",
      max_facet_values: "10000",
      filter_by: getFilterForLocationStateType(searchForm).join(" || "),
      infix: "always",
    },
    {
      query_by: "",
      collection: "posted-properties",
      q: "*",
      facet_by: "dump.location.city_name,dump.location.city_slug",
      facet_return_parent: "dump.location.city_name,dump.location.city_slug",
      filter: "true",
      max_facet_values: "10000",
      filter_by: getFilterForLocationCityType(searchForm).join(" || "),
      infix: "always",
    },
  ];
  return returnPayload;
};
